function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTime = function SvgTime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 19499"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 18594",
    style: {
      fill: "none"
    },
    d: "M0 0h18v18H0z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 19502"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 19501"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 19500"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2036",
    d: "M15 7.747h-4.52l1.827-1.88A4.693 4.693 0 0 0 5.721 5.8a4.584 4.584 0 0 0 0 6.527 4.68 4.68 0 0 0 6.587 0 4.342 4.342 0 0 0 1.36-3.26H15a6.228 6.228 0 0 1-1.76 4.194 6.036 6.036 0 0 1-8.481 0 5.894 5.894 0 0 1-.013-8.387 5.992 5.992 0 0 1 8.434 0L15 3zM9.334 6.334v2.833l2.333 1.387-.48.807-2.853-1.694V6.334z",
    transform: "translate(-.001)",
    style: {
      fill: "currentColor"
    }
  })))));
};

export default SvgTime;